import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {ClassificatorModel} from '../../../system/classificator/models/classificator.model';
import {ApiResponse, BaseModalComponent, PRIVILEGES} from 'common-shared';
import {ClassificatorValueService} from '../../../system/classificator/classificator-value.service';
import {ClassificatorValueModel} from '../../../system/classificator/models/classificator-value.model';
import {BehaviorSubject} from "rxjs";

@Component({
  selector: 'mes-web-classificator-edit-modal',
  templateUrl: './classificator-edit-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClassificatorEditModalComponent extends BaseModalComponent implements OnInit {
  classificatorId: string;
  classificatorName: string;
  classificatorValueName: string;
  classificatorValueId: string;
  classificator: ClassificatorModel = new ClassificatorModel();
  response: ApiResponse<any>;
  isPristine$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  protected readonly PRIVILEGES = PRIVILEGES;

  constructor(private classificatorValueService: ClassificatorValueService, private changeDetector: ChangeDetectorRef) {
    super();
  }

  ngOnInit() {
    if (this.classificatorId) {
      this.classificatorValueService.loadOne(this.classificatorId).subscribe(value => {
        this.classificator = value;
        this.addValueIfNeeded();
        this.changeDetector.detectChanges();
      });
    } else {
      this.classificator = new ClassificatorModel({Code: this.classificatorName, Name: this.classificatorName});
      this.addValueIfNeeded();
      this.changeDetector.detectChanges();
    }
  }

  onChanged(isPristine: boolean) {
    this.isPristine$.next(isPristine);
  }

  private addValueIfNeeded() {
    if (this.classificatorValueName) {
      this.classificator.Values.push(new ClassificatorValueModel({
        Code: this.classificatorValueName, Value: this.classificatorValueName
      }));
    }
  }

  save(withClose: boolean = true) {
    this.classificatorValueService.save(this.classificator).subscribe({next: value => {
      this.classificator = value;
      this.onChanged(true);
      if (withClose) {
        this.close();
      }
    }, error: value1 => {
      this.response = value1.error;
    }});
  }

  delete() {
    this.classificatorValueService.remove(this.classificator).subscribe({next: value => {
      this.classificatorId = null;
      this.close();
    }, error: value1 => {
      this.response = value1.error;
    }});
  }

  add() {
    this.classificatorValueService.addNew(this.classificator).subscribe({next: value => {
      this.classificatorId = value.Id;
      this.close();
    }, error: value1 => {
      this.response = value1.error;
    }});
  }
}
